module.exports = __webpack_public_path__ + "img/exclamation_mark.4a10f443.svg";